"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
var core_1 = require("@aws-amplify/core");
var cache_1 = require("@aws-amplify/cache");
var logger = new core_1.ConsoleLogger('BaseProvider');
var BaseProvider = /** @class */ (function () {
    function BaseProvider(options) {
        this._config = {};
        if (options)
            this.configure(options);
        this._credentialsTokenSource = BaseProvider.ID_TOKEN;
    }
    BaseProvider.prototype.configure = function (options) {
        Object.assign(this._config, options);
        var _a = this._config, storage = _a.storage, _b = _a.refreshHandlers, refreshHandlers = _b === void 0 ? {} : _b;
        this._storage = storage;
        this._storageSync = this._storage && typeof this._storage['sync'] === 'function' ?
            this._storage['sync']() : Promise.resolve();
        this._refreshHandler =
            refreshHandlers[this.getProviderName()] ||
                refreshHandlers[this._credentialsDomain];
    };
    BaseProvider.prototype.getProviderName = function () {
        return 'Base';
    };
    BaseProvider.prototype.getCategory = function () {
        return 'Auth';
    };
    BaseProvider.prototype.setSession = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _keyPrefix, username, attributes, tokens, expires_at, provider, federatedWithIDP, errorHandler, otherProps, session, user, sessionKey, userKey, credentials, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _keyPrefix = this._config._keyPrefix;
                        username = params.username, attributes = params.attributes, tokens = params.tokens, expires_at = params.expires_at, provider = params.provider, federatedWithIDP = params.federatedWithIDP;
                        federatedWithIDP.domain = federatedWithIDP.domain || this._credentialsDomain;
                        federatedWithIDP.token = federatedWithIDP.token || this._credentialsTokenSource || BaseProvider.ID_TOKEN;
                        errorHandler = federatedWithIDP.errorHandler, otherProps = __rest(federatedWithIDP, ["errorHandler"]);
                        session = {
                            tokens: tokens,
                            expires_at: expires_at,
                            type: types_1.SessionType.FederatedProviderSession,
                            provider: this.getProviderName(),
                            federatedWithIDP: otherProps
                        };
                        user = {
                            name: username,
                            attributes: attributes
                        };
                        // cache information
                        return [4 /*yield*/, this._storageSync];
                    case 1:
                        // cache information
                        _a.sent();
                        sessionKey = _keyPrefix + "_session";
                        userKey = _keyPrefix + "_user";
                        this._storage.setItem(sessionKey, JSON.stringify(session));
                        this._storage.setItem(userKey, JSON.stringify(user));
                        credentials = undefined;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, core_1.Credentials.set(session, 'federation')];
                    case 3:
                        credentials = _a.sent();
                        user.id = credentials.identityId;
                        this._storage.setItem(userKey, JSON.stringify(user));
                        // backward compatibility
                        cache_1.default.setItem('federatedInfo', {
                            provider: provider,
                            token: federatedWithIDP.token === 'id_token' ? tokens.idToken : tokens.accessToken,
                            user: user,
                            expires_at: expires_at,
                            identity_id: federatedWithIDP.identityId
                        }, { priority: 1 });
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        logger.debug('Failed to get the aws credentials with the tokens provided', e_1);
                        if (errorHandler) {
                            errorHandler(e_1);
                        }
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, {
                            session: session,
                            user: user,
                            credentials: credentials
                        }];
                }
            });
        });
    };
    BaseProvider.prototype.getSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _keyPrefix, session;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _keyPrefix = this._config._keyPrefix;
                        return [4 /*yield*/, this._storageSync];
                    case 1:
                        _a.sent();
                        session = JSON.parse(this._storage.getItem(_keyPrefix + "_session"));
                        if (!session)
                            throw new Error('Session is not cached.');
                        if (session.expires_at > new Date().getTime()) {
                            logger.debug('token not expired');
                            return [2 /*return*/, session];
                        }
                        else {
                            // refresh
                            if (this._refreshHandler && typeof this._refreshHandler === 'function') {
                                logger.debug('getting refreshed jwt token from federation provider');
                                return [2 /*return*/, this._refreshHandler().then(function (data) {
                                        logger.debug('refresh federated token sucessfully', data);
                                        var newSession = null;
                                        var expires_at = session.expires_at, tokens = session.tokens, otherSessionInfo = __rest(session, ["expires_at", "tokens"]);
                                        if (_this._credentialsTokenSource === BaseProvider.ACCESS_TOKEN) {
                                            tokens.accessToken = data.token;
                                        }
                                        else {
                                            tokens.idToken = data.token;
                                        }
                                        newSession = __assign({ tokens: tokens, expires_at: data.expires_at }, otherSessionInfo);
                                        // restore the new session
                                        _this._storage.setItem(_keyPrefix + "_session", JSON.stringify(newSession));
                                        return newSession;
                                    }).catch(function (e) {
                                        logger.debug('refresh federated token failed', e);
                                        throw new Error('refreshing federation token failed: ' + e);
                                    })];
                            }
                            else {
                                logger.debug('no refresh handler for provider:', this.getProviderName());
                                throw new Error('no refresh handler for provider');
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseProvider.prototype.clearSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _keyPrefix, sessionKey, userKey;
            return __generator(this, function (_a) {
                _keyPrefix = this._config._keyPrefix;
                sessionKey = _keyPrefix + "_session";
                userKey = _keyPrefix + "_user";
                this._storage.removeItem(sessionKey);
                this._storage.removeItem(userKey);
                cache_1.default.removeItem('federatedInfo');
                return [2 /*return*/];
            });
        });
    };
    BaseProvider.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _keyPrefix;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _keyPrefix = this._config._keyPrefix;
                        return [4 /*yield*/, this._storageSync];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, JSON.parse(this._storage.getItem(_keyPrefix + "_user"))];
                }
            });
        });
    };
    BaseProvider.ACCESS_TOKEN = 'access_token';
    BaseProvider.ID_TOKEN = 'id_token';
    return BaseProvider;
}());
exports.default = BaseProvider;
//# sourceMappingURL=BaseProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/auth/lib/providers/BaseProvider.js
// module id = 151
// module chunks = 11